import React, { useState, useEffect } from "react";
import irImage from "../assets/images/ir.jpg";
import onlineImage from "../assets/images/online.jpeg";
import botImage from "../assets/images/bot.jpg";

const staticProjects = [
  {
    title: "Retrieval System For Sidaamu Afoo",
    description:
      "A retrieval system designed to improve information access for the Sidaamu Afoo language community, This project involved creating a retrieval system specifically designed for Sidaamu Afoo, a Cushitic language spoken in Ethiopia. The system aims to improve access to information, linguistic resources, and cultural content for the Sidaamu Afoo community.",
   
    type: "static",
  },
  {
    title: "Online Examination System for Addis Ababa University",
    description: "A system designed to manage and conduct online exams efficiently for students of Addis Ababa University.",
   
    type: "static",
  },
  {
    title: "Mini Auditor Telegram Bot",
    description:
      "Mini Auditor is a Telegram bot designed to simplify the process of financial auditing for small business owners. This bot helps with tracking expenses, organizing receipts, and generating basic reports.",
    
    type: "static",
  },
];

const Projects = () => {
  const [likes, setLikes] = useState(staticProjects.map(() => 0));
  const [githubProjects, setGithubProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allProjects, setAllProjects] = useState([]);

  // Fetch repositories from GitHub - sorted by most recently updated
  useEffect(() => {
    const fetchGithubProjects = async () => {
      try {
        const response = await fetch("https://api.github.com/users/abateIS/repos?sort=updated&direction=desc");
        const data = await response.json();
        // Get only the 5 most recent repos (sorted by updated_at)
        const recentProjects = data
          .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
          .slice(0, 5);
        setGithubProjects(recentProjects);
      } catch (error) {
        console.error("Error fetching GitHub repositories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchGithubProjects();
  }, []);

  // Combine all projects when GitHub projects are loaded
  useEffect(() => {
    if (!loading) {
      const combined = [
        ...staticProjects,
        ...githubProjects.map((repo) => ({
          title: repo.name,
          description: repo.description || "No description available.",
          type: "github",
          html_url: repo.html_url,
        })),
      ];
      setAllProjects(combined);
    }
  }, [loading, githubProjects]);

  const handleLike = (index) => {
    if (allProjects[index] && allProjects[index].type === "static") {
      const staticIndex = staticProjects.findIndex(
        (p) => p.title === allProjects[index].title
      );
      if (staticIndex !== -1) {
        const updatedLikes = [...likes];
        updatedLikes[staticIndex] += 1;
        setLikes(updatedLikes);
      }
    }
  };

  const getLikeCount = (index) => {
    if (allProjects[index] && allProjects[index].type === "static") {
      const staticIndex = staticProjects.findIndex(
        (p) => p.title === allProjects[index].title
      );
      return staticIndex !== -1 ? likes[staticIndex] : 0;
    }
    return 0;
  };

  if (loading) {
    return (
      <div className="projects container" style={styles.container}>
        <div style={styles.loadingContainer}>
          <p style={styles.loadingText}>Loading projects...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="projects container" style={styles.container}>
      <div style={styles.projectsGrid}>
        {allProjects.map((project, index) => (
          <div className="project-card" key={index} style={styles.card}>
            {project.image && (
              <div style={styles.imageContainer}>
                <img
                  src={project.image}
                  alt={project.title}
                  style={styles.image}
                />
              </div>
            )}
            <div style={styles.cardContent}>
              <h3 style={styles.title}>{project.title}</h3>
              <p style={styles.description}>{project.description}</p>
              <div style={styles.cardFooter}>
                {project.type === "static" ? (
                  <button
                    style={styles.likeButton}
                    onClick={() => handleLike(index)}
                  >
                    👍 {getLikeCount(index)}
                  </button>
                ) : (
                  <a
                    href={project.html_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                  >
                    View on GitHub →
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "40px 20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  projectsGrid: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    width: "100%",
  },
  card: {
    background: "rgba(255, 255, 255, 0.95)",
    border: "1px solid #e0e0e0",
    borderRadius: "16px",
    overflow: "hidden",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    maxWidth: "1000px",
    margin: "0 auto",
  },
  imageContainer: {
    width: "40%",
    minWidth: "300px",
    height: "auto",
    minHeight: "200px",
    overflow: "hidden",
    background: "#f5f5f5",
    flexShrink: 0,
  },
  cardMobile: {
    flexDirection: "column",
  },
  imageContainerMobile: {
    width: "100%",
    minWidth: "100%",
    height: "250px",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "transform 0.3s ease",
  },
  cardContent: {
    padding: "30px",
    flex: "1",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  title: {
    fontSize: "1.8rem",
    color: "#0077b6",
    marginBottom: "15px",
    fontWeight: "600",
  },
  description: {
    fontSize: "1.1rem",
    color: "#555",
    lineHeight: "1.8",
    flex: "1",
    marginBottom: "20px",
  },
  cardFooter: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: "auto",
  },
  likeButton: {
    backgroundColor: "#0077b6",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    cursor: "pointer",
    fontSize: "1rem",
    fontWeight: "500",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  link: {
    color: "#0077b6",
    textDecoration: "none",
    fontWeight: "600",
    fontSize: "1rem",
    transition: "color 0.3s ease",
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
  },
  loadingContainer: {
    textAlign: "center",
    padding: "40px",
    background: "rgba(255, 255, 255, 0.95)",
    borderRadius: "12px",
  },
  loadingText: {
    fontSize: "1.2rem",
    color: "#666",
  },
};

export default Projects;
